import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  sectionTitleLabel: {
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(2)
  }
});

export default makeStyles(styles);
